import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import { ThreeDotMenu } from 'new/elements/ThreeDotMenu';

interface Props {
  actions: any[];
  components: Record<string, React.ReactNode>;
}

export interface PopoverMenuRef {
  unselectComponent(): void;
  selectComponent(key: string): void;
}

export const usePopoverMenu = () => useRef<PopoverMenuRef>();
const PopoverMenu = (props: Props, ref: React.Ref<PopoverMenuRef>) => {
  const { actions, components } = props;
  const [selectedComponent, setComponent] = useState<string>('');

  const resolvedActions = (() => {
    return actions.map((act: any) => {
      return {
        ...act,
        onClick: () => {
          setComponent(act.key);
          if (typeof act?.onClick === 'function') {
            act.onClick();
          }
        },
      };
    });
  })();

  useImperativeHandle(ref, () => ({
    selectComponent: (key: string) => {
      if (components[key]) {
        setComponent(key);
      }
    },
    unselectComponent: () => {
      setComponent('');
    },
  }));

  return (
    <>
      <ThreeDotMenu actions={[{ actions: resolvedActions }]} />
      {components[selectedComponent]}
    </>
  );
};

export default forwardRef(PopoverMenu);
